import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { updateDates } from '../../global/utils/dateTranslator';
import { Layout, RadioGroup } from '@hub-mono/ui';

export const predefinedOtherOption = {
    label: 'Custom',
    value: 'other',
    dataCy: 'range-option-other',
};

export const predefinedDateRangesOptions = [
    {
        dateState: 'This',
        periodType: 'week',
        label: 'This Week',
        dataCy: 'range-option-this-week',
        value: 'this-week',
        getRange: weekType => updateDates('this', null, weekType),
    },
    {
        dateState: 'Next',
        periodType: 'week',
        label: 'Next week',
        value: 'next-week',
        dataCy: 'range-option-next-week',
        getRange: weekType => updateDates('add', { week: 1 }, weekType),
    },
    {
        dateState: 'This',
        periodType: 'month',
        label: 'This month',
        value: 'this-month',
        dataCy: 'range-option-this-month',
        getRange: () => updateDates('this', null, 'month'),
    },
    {
        dateState: 'Next',
        periodType: 'month',
        label: 'Next month',
        value: 'next-month',
        dataCy: 'range-option-next-month',
        getRange: () => updateDates('add', { months: 1 }, 'month'),
    },
    predefinedOtherOption,
];

const PredefinedDates = props => {
    const { onSelect, selected, disabled, variant } = props;

    const handleChange = useCallback(
        value => {
            onSelect(predefinedDateRangesOptions.find(dateRange => dateRange.value === value));
        },
        [onSelect]
    );

    return (
        <Layout hAlign={variant === 'builder' ? 'center' : 'flex-start'} gap="--Spacing-150">
            <RadioGroup
                disabled={disabled}
                value={selected}
                name="group"
                options={predefinedDateRangesOptions}
                optionLabel="label"
                optionValue="value"
                onChange={handleChange}
            />
        </Layout>
    );
};

PredefinedDates.propTypes = {
    onSelect: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

const memoized = React.memo(PredefinedDates);

export { memoized as PredefinedDates };
